import { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Flex, FullscreenTakeover, QueryLoader } from "@jsq/ds/core";
import { useQueryParam } from "~/common/hooks/useQueryParams";
import { useGetProposedProfileDetailsQuery } from "~/graphql/supergraphHooks";
import { DocumentsViewPanel } from "../../CaseDetailsDrawer/Documents/DocumentManagement/DocumentManagementDisplay/DocumentsViewPanel";
import { useCurrentCaseContext } from "../../context/CurrentCaseContext";
import { RETURN_TO_REVIEW } from "../../ProposedChangesReview/constants";
import { DocumentList } from "../DocumentList";
import { DocumentDetails } from "../info/DocumentDetails";
import { ProfileDetails } from "../info/ProfileDetails";
import { closeButton, panelWrapper, previewPanel, rightPanel } from "./styles_vanilla.css";

export const ProposeChangePreview = () => {
  const history = useHistory();
  const { sourceProfile, targetProfile } = useParams<{
    sourceProfile: string;
    targetProfile: string;
  }>();
  const [docId] = useQueryParam("documentId");
  const [profId] = useQueryParam("profileId");
  const [returnTo] = useQueryParam("returnTo");
  const [latestVersionId] = useQueryParam("latestVersionId");
  const documentId = docId ? parseInt(docId) : 0;
  const profileId = profId ? parseInt(profId) : 0;
  const { caseBasePath } = useCurrentCaseContext();

  const profileResult = useGetProposedProfileDetailsQuery({
    variables: { profileId: profileId ?? 0 },
    skip: profileId === 0,
    fetchPolicy: "cache-and-network",
  });

  const rawDocument = (profileResult.data?.complianceProfile?.documents ?? []).find(
    (d) => d.id === documentId,
  );
  const document = rawDocument
    ? {
        id: rawDocument.id,
        name: rawDocument.name,
        s3Link: rawDocument.s3Link,
        profileId: parseInt(sourceProfile),
      }
    : null;

  const headerTitle = useMemo(() => {
    return `Document upload · ${document?.name ?? "--"}`;
  }, [document?.name]);

  const onClose = () => {
    const base = `${caseBasePath}/profiles/${sourceProfile}/proposed-changes/${targetProfile}`;
    if (returnTo !== RETURN_TO_REVIEW) {
      history.push(base);
      return;
    }
    const query = latestVersionId
      ? `?${new URLSearchParams({ latestVersionId }).toString()}`
      : "";
    history.push(`${base}/review${query}`);
  };

  return (
    <FullscreenTakeover>
      <FullscreenTakeover.Header onExit={onClose} title={headerTitle} />
      <QueryLoader result={profileResult}>
        <FullscreenTakeover.Body style={{ padding: 0, gap: 0 }}>
          <Flex className={panelWrapper}>
            <DocumentList documents={document ? [document] : []} />
          </Flex>
          <div className={previewPanel}>
            <DocumentsViewPanel documentId={documentId} />
          </div>
          <Flex className={rightPanel}>
            <ProfileDetails profileInfo={profileResult.data?.complianceProfile ?? null} />
            {rawDocument && <DocumentDetails document={rawDocument} />}
            <Button variant="neutral" onClick={onClose} className={closeButton}>
              Close
            </Button>
          </Flex>
        </FullscreenTakeover.Body>
      </QueryLoader>
    </FullscreenTakeover>
  );
};
